export default __webpack_public_path__ + "static/media/audio_bg.8d84875d.svg";